/**
=========================================================
* Material Dashboard 3 PRO React - v2.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Images
import productImage from "assets/images/products/product-11.webp";
// import * as React from 'react';
import { styled } from "@mui/material/styles";
// import Button from '@mui/material/Button';
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useState } from "react";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

function ArticleImage({
  articleImage,
  imgInfo,
  changeHandler,
  notification,
  setNotification,
  errors,
  setErrors,
  name,
}) {
  const [imageUrl, setImageUrl] = useState(null);
  const productImage1 = imageUrl || articleImage;

  const changeHandler1 = (e) => {
    changeHandler({ target: { name: name, value: e.target.files[0] } });
    setImageUrl(URL.createObjectURL(e.target.files[0]));
  };

  return (
    <Card
      sx={{
        "&:hover .card-header": {
          transform: "translate3d(0, -50px, 0)",
        },
        border: errors[name] ? "1px solid #e41616" : null,
      }}
    >
      {productImage1 ? (
        <MDBox
          position="relative"
          borderRadius="lg"
          mt={2}
          mx={2}
          className="card-header"
          sx={{
            transition: "transform 300ms cubic-bezier(0.34, 1.61, 0.7, 1)",
          }}
        >
          <MDBox
            component="img"
            src={productImage1 || productImage}
            alt="Product Image"
            borderRadius="lg"
            shadow="sm"
            width="100%"
            height="100%"
            position="relative"
            zIndex={10}
            mb={2}
          />
        </MDBox>
      ) : (
        <MDBox textAlign="center" pt={2} px={3}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="60px"
            viewBox="0 0 24 24"
            width="60px"
            fill="#FF5528"
          >
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z" />
          </svg>
        </MDBox>
      )}
      <MDBox textAlign="center" pt={2} pb={3} px={3}>
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          mt={productImage1 && -10}
          position={productImage1 && "relative"}
          zIndex={productImage1 && 1}
        >
          <MDBox mr={1}>
            <MDButton
              variant="gradient"
              color="info"
              size="small"
              component="label"
              role={undefined}
              onChange={changeHandler1}
              tabIndex={-1}
              startIcon={<CloudUploadIcon />}
            >
              {productImage1 ? "edit" : "upload"}
              <VisuallyHiddenInput
                type="file"
                onChange={(event) => console.log(event.target.files)}
                multiple
              />
            </MDButton>
          </MDBox>
          {/* <MDButton variant="outlined" color="dark" size="small">
            remove
          </MDButton> */}
        </MDBox>
        <MDTypography variant="h5" fontWeight="regular" sx={{ mt: 4 }}>
          {imgInfo?.name}
        </MDTypography>
        <MDTypography variant="body2" color="text" sx={{ mt: 1.5, mb: 1 }}>
          {imgInfo?.dimentions || ""} px
        </MDTypography>
      </MDBox>
    </Card>
  );
}

export default ArticleImage;
